export default "__VITE_ASSET__DyHSv4QJ__"